export const CREDIT_PACKS = {
  welcome: {
    price: 0,
    credits: 5,
    backendName: 'welcome',
  },
  early_adopter: {
    price: 0,
    credits: 5,
    backendName: 'early_adopter',
  },
  discovery: {
    price: 3000,
    credits: 10,
    backendName: 'discovery',
  },
};
export const SUBSCRIBE_PACKS = {
  'standard-90': {
    price: 9000,
    currency: '€',
    interval: 'month',
    countries: ['FR'],
    credits: 300,
    backendName: 'standard-90',
    trial_days: 0,
    isSpecialOffer: false,
  },
  'standard-90-tax-free': {
    price: 9000,
    currency: '€',
    interval: 'month',
    countries: ['DEFAULT'],
    credits: 300,
    backendName: 'standard-90-tax-free',
    trial_days: 0,
    isSpecialOffer: false,
  },
  'monthly-GBP': {
    price: 10800,
    currency: '£',
    interval: 'month',
    countries: ['GB'],
    credits: 300,
    backendName: 'monthly-GBP',
    trial_days: 0,
    isSpecialOffer: false,
  },
  'monthly-USD': {
    price: 12000,
    currency: '$',
    interval: 'month',
    countries: ['US'],
    credits: 300,
    backendName: 'monthly-USD',
    trial_days: 0,
    isSpecialOffer: false,
  },
  'monthly-CAD': {
    price: 16000,
    currency: '$ CA',
    interval: 'month',
    countries: ['CA'],
    credits: 300,
    backendName: 'monthly-CAD',
    trial_days: 0,
    isSpecialOffer: false,
  },
  'yearly-GBP': {
    price: 180000,
    currency: '£',
    interval: 'year',
    countries: ['GB'],
    credits: 600,
    backendName: 'yearly-GBP',
    trial_days: 0,
    isSpecialOffer: true,
  },
  'offer-75': {
    price: 7500,
    currency: '€',
    interval: 'month',
    countries: ['DEFAULT'],
    credits: 300,
    backendName: 'offer-75',
    trial_days: 0,
    isSpecialOffer: true,
  },
};
